import { useQuery } from "react-query";
import { fetchTaskLabels } from "@/services/tasks";
/** Query hook for the task label catalog of a workspace. */
export function useTaskLabels(workspaceId) {
  return useQuery(["task-labels", workspaceId], function () {
    return fetchTaskLabels(workspaceId);
  }, {
    enabled: Boolean(workspaceId)
  });
}